
<section>
  <div class="container-fluid mt-2">
    <div class="row border Page-Header">
      <div class="col-md-12">
        <h6 class="HeadContent d-flex align-items-center">
          <span>Exam Agencies</span>
          <span title="Add Exam Agency" (click)="addExamAgency()">
            <i class="fa fa-plus-circle ms-3 plus-icon fs-2"></i>
          </span>
        </h6>
      </div>
    </div>


    <div *ngIf="examAgencies?.length" class="row border Page-Header">
      <div class="col-md-12 scroll-style">
        <table class="table table-bordered table-hover table-responsive sticky-header"  #table1>
          <thead >
            <tr class="table-active border-none">
              <th scope="col" style="width: 25em"  sortable="Exam_Agency_Name" #examHeader (sort)="onSort($event)">
                <div class="d-flex justify-content-center">
                  <b>Exam Agency Name</b>
                  <i *ngIf="sortColumn === 'Exam_Agency_Name'"
                class=" ms-1 fa"
                [class.fa-sort-asc]="sortDirection === 'asc'"
                [class.fa-sort-desc]="sortDirection === 'desc'"
                [class.mt-2]="sortDirection === 'desc'"
                ></i>
                </div>
              </th>
              <th scope="col" sortable="Website_Address" (sort)="onSort($event)">
                <div class="d-flex justify-content-center">
                  <b>Website</b>
                  <i *ngIf="sortColumn === 'Website_Address'"
                  class=" ms-1 fa"
                  [class.fa-sort-asc]="sortDirection === 'asc'"
                  [class.fa-sort-desc]="sortDirection === 'desc'"
                  [class.mt-2]="sortDirection === 'desc'"
                  ></i>
                </div>
              </th>
              <th scope="col" sortable="Primary_Phone_Number" (sort)="onSort($event)">
                <div class="d-flex justify-content-center">
                  <b>Phone Number</b>
                  <i *ngIf="sortColumn === 'Primary_Phone_Number'"
                  class=" ms-1 fa"
                  [class.fa-sort-asc]="sortDirection === 'asc'"
                  [class.fa-sort-desc]="sortDirection === 'desc'"
                  [class.mt-2]="sortDirection === 'desc'"
                  ></i>
                </div>
              </th>
              <th scope="col">
                <div class="d-flex justify-content-center">
                  <b>Address</b>
                </div>
              </th>
              <th scope="col">
                <div class="d-flex justify-content-center">
                  <b>Description</b>
                </div>
              </th>
              <th scope="col">
                <div class="d-flex justify-content-center">
                  <b>Status</b>
                </div>
              </th>
              <th scope="col">
                <div class="d-flex justify-content-center">
                  <b></b>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let examAgency of examAgencies; let i = index"
              (click)="getCourseMaster(examAgency)"
              [class.bg-selected-row]="examAgency.Exam_Agency_Id === examAgencyId"
            >
            <td>
              <div class="column-ellipsis" >
                {{ examAgency.Exam_Agency_Name }}
              </div>
            </td>
              <td>
                <div>
                  <a
                    target="_blank"
                    [href]="getWebsiteLink(examAgency.Website_Address)"
                    >{{ getWebsiteLink(examAgency.Website_Address) }}</a
                  >
                </div>
              </td>
              <td>
                <div [ngClass]="['d-flex', getAlignment(examAgency.Exam_Agency_Name)]">
                  {{ examAgency.Primary_Phone_Number }}
                </div>
              </td>
              <td [title]="getFullAddress(examAgency)">
                <div
                class="column-ellipsis"
                >
                {{ examAgency.Address_Line_1 }}
                <ng-container *ngIf="examAgency.Address_Line_2">, {{ examAgency.Address_Line_2 }}</ng-container>
                <ng-container *ngIf="examAgency.Address_Line_3">, {{ examAgency.Address_Line_3 }}</ng-container>
              </div>
              </td>
              <td [title]="examAgency.Agency_Description">
                <div class="column-ellipsis"
                 [innerHTML]="examAgency.Agency_Description" >
                </div>
              </td>
              <td>
                <div>
                  {{examAgency.Exam_Agency_Status_Type_Name}}
                </div>
              </td>
              <td class="pointer-cursor" (click)="mutateExamAgency('Edit', examAgency)">
                <div>
                  <i
                    class="fa fa-pencil "
                  ></i>
                  <!-- <i
                    class="fa fa-eye mx-2"
                    (click)="mutateExamAgency('View', examAgency)"
                  ></i> -->
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" *ngIf="!examAgencies?.length">
      <div class="col-md-12 d-flex justify-content-center mt-2">No Content</div>
    </div>

    <!-- <div class="row">
      <span class="mt-2">
        <button
          type="button"
          class="btn btn-sm bl-btn"
          (click)="addExamAgency()"
        >
          Add Exam Agency
        </button>
      </span>
    </div> -->
  </div>
</section>

<section class="mt-5" *ngIf="examAgencies?.length">
  <div class="container-fluid mt-2">
    <!-- <div class="row mb-2">
      <span class="mt-2">
        <button
          type="button"
          class="btn btn-sm bl-btn"
          (click)="addCourseMaster()"
        >
          Add Course Master
        </button>
      </span>
    </div> -->
    <div class="row border Page-Header">
      <div class="col-md-12">
        <h6 class="HeadContent d-flex align-items-center">
          <span>Course Master - {{ examAgencyName }}</span>
          <span title="Add Course Master" (click)="addCourseMaster()">
            <i class="fa fa-plus-circle plus-icon ms-3 fs-2 pointer-cursor"></i>
          </span>

        </h6>
      </div>
    </div>

    <section *ngIf="courseMasters?.length">
      <div class="row border Page-Header">
        <div class="col-md-12 scroll-style">
          <table class="table table-bordered table-hover table-responsive sticky-header">
            <thead >
              <tr class="table-active border-none">
                <th scope="col" sortable="Exam_Short_Name" (sort)="onSortCourseMaster($event)">
                  <div class="d-flex justify-content-center">
                    <b>Short Name</b>
                    <i *ngIf="sortColumnCourseMaster === 'Exam_Short_Name'"
                    class=" ms-1 fa"
                    [class.fa-sort-asc]="sortDirectionCourseMaster === 'asc'"
                    [class.fa-sort-desc]="sortDirectionCourseMaster === 'desc'"
                    [class.mt-2]="sortDirectionCourseMaster === 'desc'"
                    ></i>
                  </div>
                </th>
                <th scope="col" sortable="Course_Name" (sort)="onSortCourseMaster($event)">
                  <div class="d-flex justify-content-center">
                    <b> Course Name </b>
                    <i *ngIf="sortColumnCourseMaster === 'Course_Name'"
                    class=" ms-1 fa"
                    [class.fa-sort-asc]="sortDirectionCourseMaster === 'asc'"
                    [class.fa-sort-desc]="sortDirectionCourseMaster === 'desc'"
                    [class.mt-2]="sortDirectionCourseMaster === 'desc'"
                    ></i>
                  </div>
                </th>
                <th scope="col" sortable="Location_Name" (sort)="onSortCourseMaster($event)">
                  <div class="d-flex justify-content-center">
                    <b> Location/Region </b>
                    <i *ngIf="sortColumnCourseMaster === 'Location_Name'"
                    class=" ms-1 fa"
                    [class.fa-sort-asc]="sortDirectionCourseMaster === 'asc'"
                    [class.fa-sort-desc]="sortDirectionCourseMaster === 'desc'"
                    [class.mt-2]="sortDirectionCourseMaster === 'desc'"
                    ></i>
                  </div>
                </th>
                <th scope="col" sortable="Exam_Level_Type_Name" (sort)="onSortCourseMaster($event)">
                  <div class="d-flex justify-content-center">
                    <b> Exam Level </b>
                    <i *ngIf="sortColumnCourseMaster === 'Exam_Level_Type_Name'"
                    class=" ms-1 fa"
                    [class.fa-sort-asc]="sortDirectionCourseMaster === 'asc'"
                    [class.fa-sort-desc]="sortDirectionCourseMaster === 'desc'"
                    [class.mt-2]="sortDirectionCourseMaster === 'desc'"
                    ></i>
                  </div>
                </th>
                <th scope="col" sortable="Exam_Difficulty_Level_Type_Name" (sort)="onSortCourseMaster($event)">
                  <div class="d-flex justify-content-center">
                    <b> Difficulty Level </b>
                    <i *ngIf="sortColumnCourseMaster === 'Exam_Difficulty_Level_Type_Name'"
                    class=" ms-1 fa"
                    [class.fa-sort-asc]="sortDirectionCourseMaster === 'asc'"
                    [class.fa-sort-desc]="sortDirectionCourseMaster === 'desc'"
                    [class.mt-2]="sortDirectionCourseMaster === 'desc'"
                    ></i>
                  </div>
                </th>
                <th scope="col" sortable="Exam_Duration" (sort)="onSortCourseMaster($event)">
                  <div class="d-flex justify-content-center">
                    <b> Duration </b>
                    <i *ngIf="sortColumnCourseMaster === 'Exam_Duration'"
                    class=" ms-1 fa"
                    [class.fa-sort-asc]="sortDirectionCourseMaster === 'asc'"
                    [class.fa-sort-desc]="sortDirectionCourseMaster === 'desc'"
                    [class.mt-2]="sortDirectionCourseMaster === 'desc'"
                    ></i>
                  </div>
                </th>
                <th scope="col" sortable="Number_Of_Question" (sort)="onSortCourseMaster($event)">
                  <div class="d-flex justify-content-center">
                    <b> # of Questions </b>
                    <i *ngIf="sortColumnCourseMaster === 'Number_Of_Question'"
                    class=" ms-1 fa"
                    [class.fa-sort-asc]="sortDirectionCourseMaster === 'asc'"
                    [class.fa-sort-desc]="sortDirectionCourseMaster === 'desc'"
                    [class.mt-2]="sortDirectionCourseMaster === 'desc'"
                    ></i>
                  </div>
                </th>
                <th scope="col" sortable="Total_Test_Score" (sort)="onSortCourseMaster($event)">
                  <div class="d-flex justify-content-center">
                    <b> Total Score </b>
                    <i *ngIf="sortColumnCourseMaster === 'Total_Test_Score'"
                    class=" ms-1 fa"
                    [class.fa-sort-asc]="sortDirectionCourseMaster === 'asc'"
                    [class.fa-sort-desc]="sortDirectionCourseMaster === 'desc'"
                    [class.mt-2]="sortDirectionCourseMaster === 'desc'"
                    ></i>
                  </div>
                </th>


              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let courseMaster of courseMasters; let i = index"
                [class.bg-selected-row]="courseMaster.Course_Master_Id === selectedCourseMaster?.Course_Master_Id"
                (click)="editCourseMasterId(courseMaster);"
                >
                <td>
                  <div class="column-ellipsis"
                  >
                    {{
                      courseMaster.Exam_Short_Name
                    }}

                  </div>
                </td>
                <td>
                  <div class="column-ellipsis">
                    {{ courseMaster.Course_Name }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ courseMaster.Location_Name }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ courseMaster.Exam_Level_Type_Name }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ courseMaster.Exam_Difficulty_Level_Type_Name }}
                  </div>
                </td>
                <td>
                  <div [ngClass]="['d-flex', getAlignment(courseMaster.Exam_Duration)]">
                    {{ courseMaster.Exam_Duration }}
                  </div>
                </td>
                <td>
                  <div [ngClass]="['d-flex', getAlignment(courseMaster.Number_Of_Question)]">
                    {{ courseMaster.Number_Of_Question }}
                  </div>
                </td>
                <td>
                  <div [ngClass]="['d-flex', getAlignment( courseMaster.Total_Test_Score )]">
                    {{ courseMaster.Total_Test_Score }}
                  </div>
                </td>


              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>

    <div class="row" *ngIf="!courseMasters?.length">
      <div class="col-md-12 d-flex justify-content-center mt-2">No Content</div>
    </div>
  </div>
</section>
